//  站点名称
const SITE_NAME = "玄月主页";
const SITE_ANTHOR = "玄月";
const SITE_URL = "Lumao.fun";
const SITE_SUB_TITLE = "——撸猫典范！";
const SITE_LOGO = "./static/images/icon/logo_white.png";

// # 简介文本
const DESC = {
  // 隐藏时描述
  false: {
    englishText: "Hello World !🌙",
    chineseText: "你不在我每天都想你！"
  },
  // 展开时描述
  true: {
    englishText: "Oops !",
    chineseText: "哎呀，这都被你发现了"
  }
};

// # 天气 Key-高德开放平台
const AMAP_KEY = "5195d100641edca5dba91a373460973b";

// # 建站日期
// ## 请按照 YYYY-MM-DD 格式填写
const SITE_START = "2023-04-15";

const time = new Date().getTime();

const BACKGROUND = {
  local: {
    url: `./static/images/background/background${Math.floor(
      Math.random() * 30 + 1
    )}.webp`,
    desc: "默认壁纸",
    key: "local"
  },
  type1: {
    url: "https://cdn.seovx.com/ha/?mom=302&time=" + time,
    desc: "古风小姐姐",
    key: "type1"
  },
  type2: {
    url: "https://api.yimian.xyz/img?type=wallpaper&time=" + time,
    desc: "随机风景",
    key: "type2"
  },
  type3: {
    url: "https://tenapi.cn/v2/acg?time=" + time,
    desc: "随机动漫",
    key: "type3"
  }
};
const EFFECT = {
  Empty: {
    key: "empty",
    desc: "不显示"
  },
  Particle: {
    key: "particle",
    desc: "跟随粒子"
  },
  Starts: {
    key: "starts",
    desc: "星空粒子"
  }
};
export default {
  SITE_NAME,
  SITE_ANTHOR,
  SITE_URL,
  SITE_SUB_TITLE,
  SITE_LOGO,
  DESC,
  AMAP_KEY,
  SITE_START,
  BACKGROUND,
  EFFECT
};

/**
 * @description live2d 配置项
 * 使用 live2d-widget.js
 * 官方文档 https://l2dwidget.js.org/docs/class/src/index.js~L2Dwidget.html
 */
export function live2dSetting() {
  // 配置文件
  return {
    tagMode: false, // 标签模式, 是否仅替换 live2d tag标签而非插入到所有页面中
    debug: false, // 调试, 是否在控制台输出日志
    model: {
      jsonPath:
        "https://unpkg.com/live2d-widget-model-tororo@1.0.5/assets/tororo.model.json", // model.json文件，模型在这里修改
      scale: 1 // 模型与canvas的缩放
    },
    display: {
      superSample: 2, // 超采样等级
      position: "right", // 显示位置：左或右
      width: 90, // canvas的长度
      height: 90, // canvas的高度
      hOffset: 0, // canvas水平偏移
      vOffset: 30 // canvas垂直偏移
    },
    react: {
      opacityDefault: 0.8, // 默认透明度
      opacityOnHover: 0.5 // 鼠标移入透明度
    },
    dev: {
      border: false // 在canvas周围显示边框
    },
    mobile: {
      show: false, // 是否在移动设备上显示
      scale: 0.5, // 移动设备上的缩放
      motion: true // 移动设备是否开启重力感应
    }
  };
}



// WEBPACK FOOTER //
// ./src/config/index.js